import axios from 'axios'
import AuthService from '@/services/AuthService';

const baseURL = process.env.NODE_ENV==='development' ? 'http://127.0.0.1:8000' : '';

const Client = axios.create(
    {
        baseURL,
        headers:{},
    }
);

const authenticationExcludedUrls = [
    '/auth/api/token/',
    '/auth/api/token/refresh/',
]

// Access token varsa header'a ekler.
Client.interceptors.request.use(async(config) => {
    if((authenticationExcludedUrls.includes(config.url))){
        return config;
    }
    if(AuthService.isLoggedIn()){
        config.headers['Authorization']='Bearer '+ await AuthService.getToken();
    }
    else{
        if(AuthService.isRememberingUser()){
            var loginStatus=await AuthService.login(localStorage.getItem('username'),localStorage.getItem('password'),false);
            if(loginStatus===true){
                config.headers['Authorization']='Bearer '+ await AuthService.getToken();
            }
        }
        else {
            window.location.reload(); // Login sayfasına atar
        }
    }
        
    return config;
})

Client.interceptors.response.use(
    (response) => response,
    (error) => {
        // 401 status code dönerse tokenları temizler ve reload atar. Bu sayede login sayfasına döneriz.
        if(error.response.status===401){
            AuthService.clearCredentials();
        }
        return Promise.reject(error)
    }
)

export default Client